import {createSelector} from '@reduxjs/toolkit';

import {GOOD_ITEM_TYPES, SENTINEL1_ID} from '@explorer/constants/item-types';
import {getSarDataLab} from '@explorer/selectors/ui';

export const getItemTypes = state => state.itemTypes;

export const getAvailableItemTypes = createSelector(
  getItemTypes,
  getSarDataLab,
  (itemTypes, sarDataLab) => {
    // TODO: Move this line to the item types reducer (this filters item types from the api that we never want)?
    const types = itemTypes.types.filter(
      itemType => itemType in GOOD_ITEM_TYPES
    );

    const selected = {...itemTypes.selected};
    const typesMap = {...itemTypes.typesMap};

    const itemTypesState = {
      ...itemTypes,
      types,
      selected,
      typesMap,
    };

    /* Remove SAR DATA ITEM TYPES (SENTINEL1_ID) if lab is disabled */
    if (!sarDataLab) {
      itemTypesState.types = itemTypesState.types.filter(
        itemType => itemType !== SENTINEL1_ID
      );
      delete typesMap[SENTINEL1_ID];
      delete selected[SENTINEL1_ID];
    }

    return itemTypesState;
  }
);

export const getSelectedItemTypes = createSelector(
  getAvailableItemTypes,
  itemTypes => itemTypes.selected
);

export const getSelectedDisplayNames = createSelector(
  getAvailableItemTypes,
  ({typesMap, selected}) =>
    Object.keys(typesMap)
      .filter(type => selected[type])
      .map(type => (typesMap[type] ? typesMap[type].display_name : type))
);

export const getDisplayName = createSelector(
  getItemTypes,
  (_, itemType) => itemType,
  ({typesMap = {}}, itemType) =>
    itemType in typesMap ? typesMap[itemType].display_name : itemType
);
